import { useMutation, useQueryClient } from "react-query";
import { REPORT_URL } from "../../../api.config";
import { useNotifications } from "../../../hooks";
import { postData } from "../../../utils/axiosHelpers";
import { Report } from "../ReportsPageTypes";
import { KEY } from "./useReports";

export default function useCreateReport() {
  const CALL_REASON = `Create New Report`;

  const { onSuccessNotification, onErrorNotification } = useNotifications();

  const queryClient = useQueryClient();

  return useMutation((values) => postData(REPORT_URL, values), {
    onMutate: async (reportToCreate: any) => {
      console.log(reportToCreate);
      await queryClient.cancelQueries(KEY);
      const previousReportsList: any = queryClient.getQueryData(KEY);

      const newReportsList = [
        ...previousReportsList?.reports,
        {
          id: Math.random().toString(),
          ...reportToCreate,
          running: true,
        },
      ];

      queryClient.setQueryData(KEY, {
        reports: newReportsList,
      });

      console.log(newReportsList);

      return {
        previousReportList: previousReportsList,
        newReportList: newReportsList,
      };
    },
    onSuccess: (data, _, context) => {
      onSuccessNotification(data, CALL_REASON);

      queryClient.setQueryData(KEY, {
        reports: context?.newReportList,
      });
    },
    onError: (data, _, context) => {
      onErrorNotification(data, CALL_REASON);
      if (context?.previousReportList) {
        queryClient.setQueryData<Report>([KEY], context.previousReportList);
      }
    },

    onSettled: () => {
      queryClient.invalidateQueries(KEY);
    },
  });
}
